module.exports = __webpack_public_path__ + "img/agility.0ebc69cd.svg";